import React from 'react'
import styles from './IEWarning.scss'

const IEWarning = () => (
  <div className={styles.root}>
    Your browser is not supported. Currently we support Google Chrome, Safari browsers.
  </div>
)

export default IEWarning
